import { Component, OnInit } from '@angular/core';
import { EnfermeiroService } from '../../enfermeiro.service';
import { NavigationExtras, Router } from '@angular/router';
import { AlertsService } from 'app/shared/alerts.service';
import { CartaoContasService } from 'app/shared/components/cartao-gestante/cartao-contas.service';
import { Paciente } from 'app/core/interfaces/pacient-info.interface';
import { FormGroup, FormControl } from '@angular/forms';
import { Enfermeiro } from 'app/core/interfaces/enfermeiro.interface';
import { Organizacao } from 'app/core/interfaces/organizacao.interface';
import { ModalsService } from 'app/shared/modals.service';
import { logger } from '../../../../core/utils/console';

@Component({
  selector: 'app-enfermeiro-pacientes',
  templateUrl: './enfermeiro-pacientes.component.html',
  styleUrls: ['./enfermeiro-pacientes.component.scss']
})
export class EnfermeiroPacientesComponent implements OnInit {

  loading = true;
  enfermeiro: Enfermeiro;
  organizacao: Organizacao;
  pacientes: Array<Paciente> = [];

  page = 1;
  limit = 12;
  total = 0;
  totalPages = 0;
  totalInPage = 0;

  inUseFiltro = false;

  form: FormGroup;

  constructor(
    private enfermeiroService: EnfermeiroService,
    private router: Router,
    private alerts: AlertsService,
    private contasService: CartaoContasService,
    private modalsService: ModalsService,
  ) { 
    try {

      const navigation = this.router.getCurrentNavigation();

      if (navigation && navigation.extras && navigation.extras.state) {
        const state = navigation.extras.state;
        if (state.page) {
          this.page = state.page;
        }
      }

    } catch(err) {

      logger.log('EnfermeiroPacientesComponent -> constructor -> err', err);

    }
  }


  ngOnInit() {
    this.form = new FormGroup({
      name: new FormControl(''),
      status: new FormControl(''),
      telefone: new FormControl(''),
      email: new FormControl(''),
      cns: new FormControl(''),
      cpf: new FormControl(''),
      dumLte: new FormControl(''),
      dumGte: new FormControl(''),
      usLte: new FormControl(''),
      usGte: new FormControl(''),
      usPartoLte: new FormControl(''),
      usPartoGte: new FormControl(''),
    });

    let stringFilter = localStorage.getItem('formPacientesFilter');

    if (stringFilter && stringFilter != '') {
      try {
        let formData = JSON.parse(stringFilter);

        this.form.setValue({ 
          name: formData.name,
          status: formData.status,
          telefone: formData.telefone,
          email: formData.email,
          cns: formData.cns,
          cpf: formData.cpf,
          dumLte: formData.dumLte,
          dumGte: formData.dumGte,
          usLte: formData.usLte,
          usGte: formData.usGte,
          usPartoLte: formData.usPartoLte,
          usPartoGte: formData.usPartoGte,
        })
      } catch(error) {
        logger.error(error)
        logger.error(stringFilter, 'error JSON');
      }
    } 

    this.AtualizarInformacoes();
  }

  scrollToTop(): void {
    if (document.getElementById('container-3')) {
      document.getElementById('container-3').scrollTo({ top: 0 , behavior: 'smooth' })
    }
  }

  AtualizarInformacoes(page: number = null) {

    if (page) this.page = page;
    this.loading = true;
    this.scrollToTop();

    this.saveFormInLocalstorage();

    // Buscando os dados do usuario 
    this.enfermeiroService.GetUserData().subscribe((dados) => {
      this.enfermeiro = dados;

      this.enfermeiroService.GetOrgData().subscribe((org) => {
        this.organizacao = org;
      });

      if (dados && dados.id) {
        let search = {
          cartaoAtivado: null,
          cartaoEncerrado: null,
          name: this.form.controls.name.value,
          telefone: this.form.controls.telefone.value,
          email: this.form.controls.email.value,
          cns: this.form.controls.cns.value,
          cpf: this.form.controls.cpf.value,
          dumLte: this.form.controls.dumLte.value,
          dumGte: this.form.controls.dumGte.value,
          usLte: this.form.controls.usLte.value,
          usGte: this.form.controls.usGte.value,
          usPartoLte: this.form.controls.usPartoLte.value,
          usPartoGte: this.form.controls.usPartoGte.value,
        };
        
        if (this.form.controls.status.value) switch (this.form.controls.status.value) {
          case 'ativados':
            search.cartaoAtivado = true;
            search.cartaoEncerrado = false;
            break;
          case 'desativados':
            search.cartaoAtivado = false;
            search.cartaoEncerrado = false;
            break;
          case 'encerrados':
            search.cartaoAtivado = true;
            break;
        }

        this.enfermeiroService.GetListaPacientePage(this.page, this.limit, search).subscribe((pagination) => {

          this.pacientes = pagination.data;
          this.page = pagination.page
          this.total = pagination.total;
          this.totalPages = pagination.totalPages;
          this.totalInPage = pagination.totalInPage;

          this.loading = false;

        }, err => {

          this.loading = false;

        });
      }
    });
  }

  saveFormInLocalstorage() {
    let formData = {
      name: this.form.controls.name.value,
      status: this.form.controls.status.value,
      telefone: this.form.controls.telefone.value,
      email: this.form.controls.email.value,
      cns: this.form.controls.cns.value,
      cpf: this.form.controls.cpf.value,
      dumLte: this.form.controls.dumLte.value,
      dumGte: this.form.controls.dumGte.value,
      usLte: this.form.controls.usLte.value,
      usGte: this.form.controls.usGte.value,
      usPartoLte: this.form.controls.usPartoLte.value,
      usPartoGte: this.form.controls.usPartoGte.value,
    }

    localStorage.setItem('formPacientesFilter', JSON.stringify(formData));
  }

  visibleBtnClear() {

    return this.form.controls.name.value != '' || this.form.controls.status.value != '' ||
      this.form.controls.telefone.value != '' || this.form.controls.email.value != '' ||
      this.form.controls.cns.value != '' || this.form.controls.cpf.value != '' ||
      this.form.controls.dumLte.value != '' || this.form.controls.dumGte.value != '' ||
      this.form.controls.usLte.value != '' || this.form.controls.usGte.value != '' ||
      this.form.controls.usPartoLte.value != '' || this.form.controls.usPartoGte.value != '';

  }

  async VerCartao(item) {
    try {
      const cartao_ativo = await this.enfermeiroService.LerUltimoCartao(item.id);

      if (cartao_ativo == null) {
        this.alerts.SnackMessage('Usuário não possui um cartão ativo');
      } else {
        const navigationExtras: NavigationExtras = {
          state: {
            cartao_id: cartao_ativo.id,
            paciente_id: item.id,
            oldPage: this.page,
          }
        };
        
        this.router.navigate(['/enfermeiro-alterar-cartao-gestante'], navigationExtras);
      }
    } catch (error) {

      this.alerts.SnackMessage('Sem permissão para alterar o cartão do paciente');

    }
  }

  nextPage() {
    this.AtualizarInformacoes(this.page + 1);
  }

  EditarPaciente(item) {
    const navigationExtras: NavigationExtras = {
      state: {
        paciente: item.email,
        id: item.id,
        oldPage: this.page,
      }
    };
    this.router.navigate(['/enfermeiro-alterar-pacientes'], navigationExtras);
  }

  async NovaConsulta(item) {
    try {
      // Ler o cartão ativo do paciente 
      const cartao_ativo = await this.enfermeiroService.LerCartaoAtivoPaciente(item.id);

      if (cartao_ativo == null) {
        this.alerts.SnackMessage('Usuário não possui um cartão ativo');
      } else {
        const extras: NavigationExtras = {
          state: {
            paciente: item,
            cartao: cartao_ativo,
          }
        };

        this.router.navigate(['/enfermeiro-nova-consulta'], extras);
      }
    } catch (error) {

    }
  }

  ValorSemanasGestacaoDum(valor, parto?: string | Date) {
    const aux = this.contasService.SemanasGestacaoDum(valor, parto);
    return isNaN(aux) ? null : aux;
  }

  ValorSemanasGestacaoUs(us: string | Date, semanas: string, dias: string, parto?: string | Date) {
    const aux = this.contasService.SemanasGestacaoUs(us, semanas, dias, parto);
    return isNaN(aux) ? null : aux;
  }

  PrevisaoGestacaoDum(valor) {
    const aux = this.contasService.PrevisaoDum(valor);
    return aux;
  }

  PrevisaoGestacaoUSG(us, semanas, dias) {
    const aux = this.contasService.PrevisaoUltrassom(us, semanas, dias);
    return aux;
  }

  limparFiltro() {
    this.form = new FormGroup({
      name: new FormControl(''),
      status: new FormControl(''),
      telefone: new FormControl(''),
      email: new FormControl(''),
      cns: new FormControl(''),
      cpf: new FormControl(''),
      dumLte: new FormControl(''),
      dumGte: new FormControl(''),
      usLte: new FormControl(''),
      usGte: new FormControl(''),
      usPartoLte: new FormControl(''),
      usPartoGte: new FormControl(''),
    });

    this.AtualizarInformacoes();
  }
  
  openModalSearch() {
    const dataForm: FormSearchPacientes = {
      name: this.form.controls.name.value,
      status: this.form.controls.status.value,
      telefone: this.form.controls.telefone.value,
      email: this.form.controls.email.value,
      cns: this.form.controls.cns.value,
      cpf: this.form.controls.cpf.value,
      dumLte: this.form.controls.dumLte.value,
      dumGte: this.form.controls.dumGte.value,
      usLte: this.form.controls.usLte.value,
      usGte: this.form.controls.usGte.value,
      usPartoLte: this.form.controls.usPartoLte.value,
      usPartoGte: this.form.controls.usPartoGte.value,
    }

    this.modalsService.AbrirModalSearchPacientes(dataForm).subscribe((res) => {
      if (res) {
        this.form.setValue({
          name: res.name,
          status: res.status,
          telefone: res.telefone,
          email: res.email,
          cns: res.cns,
          cpf: res.cpf,
          dumLte: res.dumLte,
          dumGte: res.dumGte,
          usLte: res.usLte,
          usGte: res.usGte,
          usPartoLte: res.usPartoLte,
          usPartoGte: res.usPartoGte,
        });

        this.AtualizarInformacoes();
      }
    });
  }
}
